// extracted by mini-css-extract-plugin
module.exports = {"sectionContent":"FaqsPage_sectionContent__1zoFC","title":"FaqsPage_title__29uH3","list":"FaqsPage_list__HksWr","sectionWhite":"FaqsPage_sectionWhite__Y1tP9"};